export const getLayerStrokeJoin = (layer) => {
  if (!layer.strokeJoin) {
    return 'MITER';
  }

  return layer.strokeJoin;
};
